<template>
  <div id="dashboard">
    <div class="block block-rounded">
      <!-- 全部设备 -->
      <div class="dataTables_wrapper dt-bootstrap4 no-footer">
        <div class="row mb-1">
          <div class="col-12 col-md-4 text-center text-md-left">
            <pageSize @changePageSize="changePageSize"></pageSize>
          </div>
          <div class="col-12 col-md-4 text-center text-md-center" v-show="!isMobile">
            <div class="dt-buttons">
              <button
                class="dt-button buttons-copy buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                tabindex="0"
                aria-controls="DataTables_Table_1"
                data-clipboard-text
                @click="copy()"
                type="button"
                id="copybtnAllDevice"
              >
                <span>复制</span>
              </button>
              <button
                class="dt-button buttons-csv buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                @click="exportCSV()"
                type="button"
              >
                <span>导出</span>
              </button>
              <button
                class="dt-button buttons-print btn btn-sm btn-primary mr-2 pding-btn"
                @click="print()"
              >
                <span>打印</span>
              </button>
            </div>
          </div>
          <div class="col-12 col-md-4 text-center text-md-right">
            <div class="dataTables_filter">
              <label>
                <input
                  type="search"
                  class="form-control"
                  placeholder="搜索"
                  v-model="key"
                  @keyup.enter="search()"
                />
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="table-responsive">
              <section ref="print">
                <p class="show-on-print print-title">全部</p>
                <table
                  class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                >
                  <thead>
                    <tr>
                      <th
                        class="text-center sorting"
                        style="width: 60px; min-width:60px"
                        @click="getList('PROVINCE',$event)"
                      >#</th>
                      <th
                        class="text-left sorting"
                        style="min-width: 150px;"
                        @click="getList('PROVINCE',$event)"
                      >省份</th>
                      <th
                        class="text-left sorting"
                        style="min-width: 150px;"
                        @click="getList('CITY',$event)"
                        v-if="regionParams.region!='all'"
                      >城市</th>
                      <th
                        class="text-left sorting"
                        style="min-width: 150px;"
                        @click="getList('DISTRICT',$event)"
                        v-if="regionParams.region=='city'||regionParams.region=='district'"
                      >区域</th>
                      <th
                        class="text-left sorting"
                        style="min-width: 110px;"
                        @click="getList('FLATCOMPLEX_NUM',$event)"
                        v-if="regionParams.region!='district'"
                      >小区数量</th>
                      <th
                        class="text-left sorting"
                        style="min-width: 150px;"
                        @click="getList('CELL_NAME',$event)"
                        v-if="regionParams.region=='district'"
                      >小区名称</th>
                      <th
                        class="text-left d-md-table-cell sorting"
                        style="min-width:100px;"
                        @click="getList('CARPORT_NUM',$event)"
                      >车棚数量</th>
                      <th
                        class="text-left sorting"
                        style="min-width:110px;"
                        @click="getList('METER_NUM',$event)"
                      >电表数量</th>
                      <th
                        class="text-left sorting"
                        style="min-width:110px;"
                        @click="getList('PILE_NUM',$event)"
                      >充电桩数量</th>
                      <th
                        class="text-left d-md-table-cell sorting"
                        style="min-width:110px;"
                        @click="getList('PORT_COUNT',$event)"
                      >端口数量</th>
                      <th
                        class="text-left d-md-table-cell sorting"
                        style="min-width:110px;"
                        @click="getList('UNIFIED_CONSUME_POWER',$event)"
                      >总用电量</th>
                      <th
                        class="text-left d-xl-table-cell sorting"
                        style="min-width:120px;"
                        @click="getList('REALALARM_NUM',$event)"
                      >实时告警</th>
                      <th
                        class="text-left d-xl-table-cell sorting"
                        style="min-width:110px;"
                        @click="getList('ALARM_NUM',$event)"
                      >历史告警</th>
                      <th
                        class="text-center d-xl-table-cell"
                        style="min-width:100px;"
                        v-if="isAllCell"
                      >操作</th>
                    </tr>
                  </thead>
                  <tbody v-if="meters.length">
                    <tr v-for="(item, i) in meters" :key="i">
                      <td class="text-center">{{ i + 1 }}</td>
                      <td class="text-left d-md-table-cell">{{ item.PROVINCE }}</td>
                      <td
                        class="text-left d-md-table-cell"
                        v-if="regionParams.region!='all'"
                      >{{ item.CITY }}</td>
                      <td
                        class="text-left d-md-table-cell"
                        v-if="regionParams.region=='city'||regionParams.region=='district'"
                      >{{ item.DISTRICT }}</td>
                      <td
                        class="text-left d-md-table-cell"
                        v-if="regionParams.region!='district'"
                      >{{ item.FLATCOMPLEX_NUM }}</td>
                      <td
                        class="text-left d-md-table-cell"
                        v-if="regionParams.region=='district'"
                      >{{ item.CELL_NAME }}</td>
                      <td class="text-left">{{ item.CARPORT_NUM }}</td>
                      <td class="text-left">{{ item.METER_NUM }}</td>
                      <td class="text-left">{{item.PILE_NUM}}</td>
                      <td class="text-left d-md-table-cell">{{ item.PORT_COUNT }}</td>
                      <td
                        class="text-left d-md-table-cell"
                      >{{ changeTwoDecimal(item.UNIFIED_CONSUME_POWER ) }}</td>
                      <td class="text-left">{{ item.REALALARM_NUM }}</td>
                      <td class="text-left">{{item.ALARM_NUM }}</td>
                      <td class="text-center d-xl-table-cell" v-if="isAllCell">
                        <button
                          type="button"
                          class="btn btn-primary"
                          title="查看"
                          data-original-title="Edit"
                          data-toggle="modal"
                          @click="go(item)"
                        >
                          <i class="fa fa-search"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td class="text-center" colspan="14">查无数据</td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-5 text-center text-md-left" v-show="!isMobile">
            <div class="dataTables_info" role="status" aria-live="polite">
              页数
              <strong>{{ page }}</strong> /
              <strong>{{ totalPage }}</strong>
            </div>
          </div>
          <div class="col-sm-12 col-md-7 text-center text-md-right">
            <div class="dataTables_paginate paging_full_numbers">
              <el-pagination
                v-if="meters && meters.length"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-size="pageSize"
                :small="isMobile"
                :pager-count="pagerCount"
                :layout="isMobile ? 'prev, pager, next':'total, prev, pager, next'"
                :total="total"
                background
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../Util.js";
import pageSize from "../../../components/pageSize";
export default {
  name: "index",
  data() {
    return {
      meters: [],
      entry: {},
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      clipboard: null,
      edit: "",
      cellName: "",
      sorting: "",
      orderBy: false
    };
  },
  components: {
    pageSize
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    scopeParams() {
      return this.$store.state.scopeParams;
    },
    regionParams() {
      return this.$store.state.regionParams;
    },
    isAllCell() {
      return this.$store.state.isAllCell;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getList();
        }
      },
      immediate: true,
      deep: true
    },
    key(val, oldVal) {
      if (val.length == 0) {
        this.getList();
      }
    }
  },
  mounted() {
    if (this.$route.params.scope) {
      this.$store.commit("setParam", {
        scopeParams: this.$route.params
      });
    } else if (this.$route.params.id) {
      this.$store.commit("setParam", {
        scopeParams: {
          scope: "",
          target: ""
        }
      });
    }
    this.getList();
    this.copy();
  },
  methods: {
    go(val) {
      let text, name, url, num;
      if (this.regionParams.region == "all") {
        text = "province";
        name = val.PROVINCE;
        url = "City/ListByProvince";
        num = 2;
      } else if (this.regionParams.region == "province") {
        text = "city";
        name = val.CITY;
        url = "District/ListByCity";
        num = 3;
      } else if (this.regionParams.region == "city") {
        text = "district";
        name = val.DISTRICT;
        url = "FlatComplex/ListByDistrict";
        num = 4;
      } else if (this.regionParams.region == "district") {
        text = "flatComplex";
        name = val.CELL_NAME;
        url = "FlatComplex/ListByDistrict";
        num = 4;
      }
      this.$store.commit("setParam", {
        returnKey: true,
        regionParams: {
          region: text, //all,province,city,district,flatComplex,pile , 默认是all
          object: val.TARGET_ID
        },
        localSelect: name
      });
      if (this.regionParams.region == "flatComplex") {
        this.$router.push({
          name: "allDeviceDetail",
          params: {
            id: val.TARGET_ID
          }
        });
      } else {
        this.$store.commit("setParam", {
          menuTitle: name
        });
        this.meters = [];
        this.getList();
        this.$parent.getEntry();
        this.getMenuData(url, val.TARGET_ID, num);
      }
    },
    getMenuData(url, id, num) {
      this.$http.get(`${Util.searchURL}/${url}/${id}?isMenu=true`).then(
        result => {
          if (result.data.code === 200) {
            let data = result.data.data;
            for (let i of data) {
              i.type = num;
            }
            this.$store.commit("setParam", {
              menu: data,
              fullscreenLoading: false
            });
          }
        },
        err => {
          this.$store.commit("setParam", {
            fullscreenLoading: false
          });
          console.log(err);
        }
      );
    },
    changePageSize(val) {
      this.pageSize = val;
      this.page = 1;
    },
    getList(sorting, that) {
      let params = {};
      if (this.key.length > 0) {
        params["key"] = this.key.trim();
      }
      if (sorting != undefined || this.sorting.length > 0) {
        this.sorting = sorting == undefined ? this.sorting : sorting;
        params["sort"] = this.sorting;
        params["orderBy"] = this.orderBy;

        if (that != undefined && that.currentTarget != undefined) {
          var obj = that.currentTarget;
          if (
            $(obj).is(".sorting_asc") ||
            $(obj).is(".sorting_desc") ||
            $(obj).is(".sorting")
          ) {
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_asc");
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_desc");
            $(obj).addClass(this.orderBy ? "sorting_asc" : "sorting_desc");
            this.orderBy = !this.orderBy;
            params["orderBy"] = this.orderBy;
          }
        }
      }
      this.$http
        .get(
          `${Util.searchURL}/Carport/ListByAllDevice/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params
          }
        )
        .then(res => {
          if (res.data.code === 200) {
            this.meters = res.data.data.data;
            this.total = res.data.data.pageInfo.total;
          }
        });
    },
    exportCSV() {
      let params = {};
      if (this.key) {
        params["key"] = this.key.trim();
      }
      // params['key'] =  ''
      params["down"] = 1;
      params["sort"] = this.sorting;
      params["orderBy"] = this.orderBy;
      this.$http
        .get(
          `${Util.searchURL}/Carport/ListByAllDevice/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params,
            responseType: "blob"
          }
        )
        .then(res => {
          if (res.status === 200) {
            Util.ExportCSV(res);
          }
        });
    },
    print() {
      this.$print(this.$refs.print);
    },
    copy() {
      let copyStr = document.getElementsByTagName("section")[0].innerText;
      var btn = document.getElementById("copybtnAllDevice");
      btn.setAttribute("data-clipboard-text", copyStr);
      this.clipboard = new ClipboardJS(btn);
      this.clipboard.on("success", e => {
        Util.message("succ", "复制成功");
        this.clipboard.destroy();
        e.clearSelection();
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    changeTwoDecimal(val) {
      return Util.changeTwoDecimal(val);
    },
    inputChangeFourDecimal(val) {
      return Util.inputChangeFourDecimal(val);
    },
    formatTimeG(val) {
      return Util.formatTimeG(val);
    },
    search() {
      this.page = 1;
      this.getList();
    }
  }
};
</script>